import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { fetchReviewPatient } from '../services/patient';

export function useReviewPatient() {
    const { id } = useParams<{ id: string }>();

    return useQuery({
        queryKey: ['patient', id, 'review'],
        queryFn: () => fetchReviewPatient(id!),
        enabled: id !== undefined,
        staleTime: 0
    });
}
